export const MODAL_FOOTER_HEIGHT = 110;
